// extracted by mini-css-extract-plugin
export default {"mainWrapper":"device-report-modal-module--mainWrapper--PdxQ+"};